import React, { useEffect, useState } from "react";
import { Box, Fab, FabProps, Fade } from "@mui/material";
import birdIcon from "../../assets/icon/bird-icon.svg";
import floatingAgentButtonStyles from "./floatingAgentButtonStyles";
import { AutoAwesomeRounded } from "@mui/icons-material";
import { Theme } from "@mui/system";
import { Link, LinkProps } from "react-router-dom";

type FloatingAgentButtonProps = {
  size?: Extract<FabProps["size"], "large" | "small">;
  onClick?: FabProps["onClick"];
  disabled?: FabProps["disabled"];
  componentConfigProps?: {
    component: typeof Link,
    to: LinkProps["to"],
  };
};

export default function FloatingAgentButton({ onClick, disabled, size = "large", componentConfigProps }: FloatingAgentButtonProps) {
  const [showFirst, setShowFirst] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setShowFirst((prev) => !prev);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Fab
      onClick={onClick}
      size={size}
      disabled={disabled}
      {...(componentConfigProps || {})}
      sx={{
        backgroundColor: "white",
        outline: (theme: Theme) => `2px solid ${theme.palette.accent.main}`,
      }}
    >
      <Fade in={showFirst} timeout={1000}>
        <Box
          component="img"
          src={birdIcon}
          sx={{
            ...floatingAgentButtonStyles.icon,
            ...(size === "large" ? floatingAgentButtonStyles.iconLarge : floatingAgentButtonStyles.iconSmall),
          }}
        />
      </Fade>

      <Fade in={!showFirst} timeout={1000}>
        <AutoAwesomeRounded
          sx={{
            ...floatingAgentButtonStyles.icon,
            ...(size === "large" ? floatingAgentButtonStyles.iconLarge : floatingAgentButtonStyles.iconSmall),
          }}
        />
      </Fade>
    </Fab>
  );
}
